import { render, staticRenderFns } from "./HistoryImport.vue?vue&type=template&id=2a57a93a&scoped=true"
import script from "./HistoryImport.vue?vue&type=script&lang=js"
export * from "./HistoryImport.vue?vue&type=script&lang=js"
import style0 from "./HistoryImport.vue?vue&type=style&index=0&id=2a57a93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57a93a",
  null
  
)

export default component.exports